import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Button } from '@material-ui/core'
import PublicWrapper from '../public-wrapper-v2/public-wrapper'
import useErrorStyles from './error.styles'
import STATIC_TEXT from '../../content/common.json'

export const Error = () => {
    const classes = useErrorStyles()
    const navigate = useNavigate()
    const [isInUsaRoute, setInUsaRoute] = useState(false)
    const [isBusinessTypeRoute, setBusinessTypeRoute] = useState(false)

    useEffect(() => {
        const url = window.location.href
        if (url.includes('in-usa')) {
            setInUsaRoute(true)
        } else if (url.includes('business-type')) {
            setBusinessTypeRoute(true)
        }
    }, [])

    const handleSubmit = () => {
        if (isInUsaRoute) {
            navigate('/in-usa')
        } else if (isBusinessTypeRoute) {
            navigate('/business-type')
        }
    }

    return (
        <div className={classes.trapezoidBgInUsaError}>
            <PublicWrapper
                data-testid="publicWrapper"
                displayPrivacyPolicyFooter={true}
                backgroundClass={classes.root}
                contentWrapperClass={classes.inUsaErrorWrapper}
            >
                <div className={classes.wrapper}>
                    <div className={classes.textGroup}>
                        <Typography variant="h2" className={classes.title}>
                            {STATIC_TEXT.error.title}
                        </Typography>
                        {isInUsaRoute && (
                            <Typography variant="h2" className={classes.description}>
                                {STATIC_TEXT.error.additionalContentForInUsa}
                            </Typography>
                        )}
                        {isBusinessTypeRoute && (
                            <Typography variant="h2" className={classes.description}>
                                {STATIC_TEXT.error.additionalContentForBusinessType}
                            </Typography>
                        )}
                    </div>
                    <div className={classes.buttonRow}>
                        <Button className={classes.backBtn} onClick={handleSubmit}>
                            {STATIC_TEXT.error.backButton}
                        </Button>
                    </div>
                </div>
            </PublicWrapper>
        </div>
    )
}
